<rds-accordion size="m">
  <rds-expansion-panel [(expanded)]="filtersExpanded">
    <rds-expansion-panel-header>
      <rds-panel-title>
        <h2 class="rds-expansion-panel-heading">Filters</h2>
      </rds-panel-title>
    </rds-expansion-panel-header>
    <form
      [formGroup]="filterForm"
      class="calendar-filters row gy-5 align-items-end">
      <div class="col-12 col-m-6 col-l-2">
        <rds-form-field labelPosition="top" size="m">
          <rds-control-label>Status</rds-control-label>
          <rds-select formControlName="status">
            <rds-select-option [value]="EventCalendarFiltersEnum.ALL">
              All events
            </rds-select-option>
            <rds-select-option [value]="EventCalendarFiltersEnum.APPROVED">
              Approved
            </rds-select-option>
            <rds-select-option [value]="EventCalendarFiltersEnum.IN_PROGRESS">
              Awaiting approval
            </rds-select-option>
          </rds-select>
        </rds-form-field>
      </div>
      <div class="col-12 col-m-6 col-l-2">
        <rds-form-field labelPosition="top" size="m">
          <rds-control-label>Service</rds-control-label>
          <rds-multi-select
            placeholder="Select Service"
            formControlName="service">
            @for (service of services(); track service) {
              <rds-multi-select-option [value]="service.type">{{
                service.name
              }}</rds-multi-select-option>
            }
          </rds-multi-select>
        </rds-form-field>
      </div>
      <div class="col-12 col-m-6 col-l-2">
        <rds-form-field labelPosition="top" size="m">
          <rds-control-label>Site</rds-control-label>
          <rds-multi-select
            placeholder="Select Site"
            formControlName="siteName">
            @for (site of siteNames(); track site) {
              <rds-multi-select-option [value]="site">{{
                site
              }}</rds-multi-select-option>
            }
          </rds-multi-select>
        </rds-form-field>
      </div>
      <div class="col-12 col-m-6 col-l-2">
        <rds-form-field labelPosition="top" size="m">
          <rds-control-label>Building</rds-control-label>
          <rds-multi-select
            placeholder="Select Building"
            formControlName="buildingName">
            @for (building of buildingNames(); track building) {
              <rds-multi-select-option [value]="building">{{
                building
              }}</rds-multi-select-option>
            }
          </rds-multi-select>
        </rds-form-field>
      </div>
      <div class="col-12 col-m-6 col-l-2">
        <rds-form-field labelPosition="top" size="m">
          <rds-control-label>Floor</rds-control-label>
          <rds-multi-select
            placeholder="Select Floor"
            formControlName="floorName">
            @for (floor of floorNames(); track floor) {
              <rds-multi-select-option [value]="floor">{{
                floor
              }}</rds-multi-select-option>
            }
          </rds-multi-select>
        </rds-form-field>
      </div>
      <div class="col-12 col-m-6 col-l-2">
        <button
          rds-secondary-button
          type="button"
          class="calendar-filters__clear"
          (click)="clearFilters()"
          size="m">
          Clear
        </button>
      </div>
    </form>
  </rds-expansion-panel>
</rds-accordion>
